module.exports = __webpack_public_path__ + "img/Pot1.9e9522f7.svg";